import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';

const Dashboard = () => {
  const { user, hasPermission } = useAuth();

  const cards = [
    {
      title: 'Proyectos',
      description: 'Gestiona formularios y eventos',
      link: '/projects',
      permission: 'forms',
      color: 'bg-blue-500'
    },
    {
      title: 'Voces',
      description: 'Configura voces de bienvenida',
      link: '/voices',
      permission: 'voices',
      color: 'bg-purple-500'
    },
    {
      title: 'Usuarios',
      description: 'Administra usuarios del sistema',
      link: '/users',
      permission: 'users',
      color: 'bg-green-500'
    }
  ];

  return (
    <Layout>
      <div className="px-4 sm:px-0">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Bienvenido, {user?.fullName || user?.username}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.filter(card => hasPermission(card.permission)).map((card, index) => (
            <Link
              key={index}
              to={card.link}
              className="block"
            >
              <div className={`${card.color} rounded-lg shadow-lg p-6 text-white hover:shadow-xl transition-shadow`}>
                <h3 className="text-2xl font-bold mb-2">{card.title}</h3>
                <p className="text-white/90">{card.description}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 card">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Información del Usuario</h2>
          <div className="space-y-2">
            <p><span className="font-semibold">Usuario:</span> {user?.username}</p>
            <p><span className="font-semibold">Email:</span> {user?.email}</p>
            <p><span className="font-semibold">Tipo:</span> {user?.userType?.replace('_', ' ').toUpperCase()}</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
